import { OnInit, ChangeDetectorRef } from '@angular/core';
import { UsersService } from 'src/app/modules/shared/services/users.service';
import { LocalisationService } from 'src/app/modules/shared/services/localisation.service';
import { Constants } from 'src/app/modules/shared/config/constants.config';
import { ProductsService } from 'src/app/modules/shared/services/products.service';
import { ThemeService } from '../../../shared/services/theme.service';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { Router } from '@angular/router';
import { NewsService } from '../../../shared/services/news.service';
import { forkJoin } from 'rxjs';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(usersService, localisationService, changeDetectorRef, productsService, newsService, themeService, constants, router, appLoadingEventsEmitter) {
        this.usersService = usersService;
        this.localisationService = localisationService;
        this.changeDetectorRef = changeDetectorRef;
        this.productsService = productsService;
        this.newsService = newsService;
        this.themeService = themeService;
        this.constants = constants;
        this.router = router;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.loading = true;
    }
    DashboardComponent.prototype.ngOnInit = function () {
        if (this.usersService.userProfile && this.usersService.userProfile.is_master_profile === true) {
            this.router.navigate(['master/dashboard']);
            return;
        }
        this.router.navigate(['meals']);
        // this.init();
    };
    DashboardComponent.prototype.changeTheme = function (themeKey) {
        this.themeService.changeTheme(themeKey);
    };
    DashboardComponent.prototype.init = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin([
            this.newsService.getLatestNews(),
            this.productsService.getLatestRecipe(),
            this.productsService.getLatestVideoRecipe(),
            this.usersService.getUserProfile(),
        ]).subscribe(function (_a) {
            var latestNews = _a[0], latestRecipe = _a[1], latestVideoRecipe = _a[2], userProfile = _a[3];
            _this.latestNews = latestNews;
            _this.latestRecipe = latestRecipe;
            _this.latestVideoRecipe = latestVideoRecipe;
            _this.userProfile = userProfile;
            _this.changeDetectorRef.detectChanges();
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    DashboardComponent.prototype.onWebChat = function () {
        document.body.classList.remove('hide-tidio-chat');
        window['tidioChatApi'].open();
        document.addEventListener('tidioChat-close', function () {
            document.body.classList.add('hide-tidio-chat');
        });
    };
    DashboardComponent.prototype.getYoutubeCode = function (url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : false;
    };
    return DashboardComponent;
}());
export { DashboardComponent };
